import TemplateView from "../../TemplateView"
import messageResource from "../../messageResource"
import {countStatuses, isAll, isOnlyCompletedType, isOnlyOpenType} from "../../workflowStatus/components/statusFilter/utils"

export default class StatusFilterButton extends TemplateView {
    constructor({
        getStatusMenu = () => {},
    }) {
        super()

        this.getStatusMenu = getStatusMenu

        this.state = {
            filter: {
                allSelected: true,
                statusIds: [],
                statusTypes: [],
            },
            workflowStatusesMap: {},
            isTWSEnabled: false,
        }

        this.onAnyStatePropertyChanged(['filter', 'workflowStatusesMap', 'isTWSEnabled'], () => {
            this.update();
        })
    }

    templateHtml() {
        return "<div class='statusFilterButton_taskManagement commonVisibleFilterButton whiteBackground'>" +
               "  <div class='mainIcon'>&nbsp;</div>" +
               "  <div class='label ellipsis'></div>" +
               "  <div class='downIcon'>&nbsp;</div>" +
               "</div>";
    }

    afterRender() {
        this.$label = this.find(".label");
        this.bindClick(() => {
            const statusFilterMenu = this.getStatusMenu()

            if (!statusFilterMenu.ignoreNextShowing)
                this.$el.addClass("pressed");

            statusFilterMenu.showAt(this.$el, {offset: "0px 1px"}, (filter) => {
                this.setState(filter);
                this.$el.removeClass("pressed")
            })
        });
    }

    update() {
        let label = "";

        const filter = this.state.filter;
        const statuses = this.state.workflowStatusesMap;
        const allSelected = isAll(filter)
        if (allSelected) {
            label = messageResource.getMessage("task.list.status_filter.all_short");
        } else if (isOnlyOpenType(filter)) {
            label = messageResource.getMessage("task.list.status_filter.open_short");
        } else if (isOnlyCompletedType(filter)) {
            label = messageResource.getMessage("task.list.status_filter.completed_short");
        } else {
            const statusCount = countStatuses(filter, statuses)
            if (statusCount !== 1) {
                label = messageResource.getMessage("task.list.status_filter.selected_statuses", [statusCount]);
            } else {
                const statusId = filter.statusIds[0]
                label = statuses[statusId].name
            }
        }

        this.$el.toggleClass("filtered", !allSelected)
        this.$label.text(label);
        this.$label.attr('title', label)
    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/tasksTable/StatusFilterButton.js